import React from 'react';
import CategoryScreenView from './CategoryScreenview';
import { CategoryContextProvider } from '../../context/CategoryContext';

const CategoryView = () => {
    return (
        <CategoryContextProvider>
            <CategoryScreenView />
        </CategoryContextProvider>
    );
};

export default CategoryView;
